'use client';

import { Box, IconButton, Typography } from '@mui/material';

import { getSegmentColors, segmentPreviewText } from './segmentHelpers';

import type { PathSegmentState } from '../IngestionPipelineWizardState';

interface PathChipProps {
  segment: PathSegmentState;
  isSelected: boolean;
  readOnly: boolean;
  onClick: () => void;
  onDelete: () => void;
}

export function PathChip({
  segment,
  isSelected,
  readOnly,
  onClick,
  onDelete,
}: PathChipProps) {
  const colors = getSegmentColors(segment);

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        px: '10px',
        py: '6px',
        borderRadius: '4px',
        bgcolor: colors.bg,
        color: colors.text,
        border: '1px solid',
        borderColor: isSelected ? 'primary.main' : colors.border,
        cursor: 'pointer',
        transition: 'border-color 150ms',
        userSelect: 'none',
      }}
    >
      <Typography
        variant='body2'
        sx={{
          fontFamily: 'monospace',
          fontSize: '0.875rem',
          fontWeight: 600,
          flexShrink: 0,
          minWidth: '6ch',
        }}
      >
        {segmentPreviewText(segment)}
      </Typography>

      {!readOnly && (
        <IconButton
          size='small'
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          sx={{
            padding: '2px',
            color: colors.text,
            opacity: 0.7,
            '&:hover': { opacity: 1 },
          }}
          aria-label='delete segment'
        >
          <i className='material-symbols-close-rounded text-sm' />
        </IconButton>
      )}
    </Box>
  );
}
